/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireResponseSummaryModel} from "../../models/questionnaire-response-summary-model";
import {PaginatedList} from "../../models/paginator/paginated-list";

export interface AnalyticsResponsesGetParams {
    questionnaireGuid: string;
    version?: number | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    includeTests: boolean;
    search?: string | undefined;
    sortBy?: string | undefined;
    sortDirection?: 'asc' | 'desc' | undefined;
}

export function analyticsResponsesGet(http: HttpClient, rootUrl: string, params: AnalyticsResponsesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<QuestionnaireResponseSummaryModel>>> {
    const rb = new RequestBuilder(rootUrl, analyticsResponsesGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});

    if (params.version) {
        rb.query('version', params.version);
    }
    if (params.pageNumber) {
        rb.query('pageNumber', params.pageNumber)
    }
    if (params.pageSize) {
        rb.query('pageSize', params.pageSize)
    }
    rb.query('includeTest', params.includeTests)
    if (params.search) {
        rb.query('search', params.search)
    }
    if (params.sortBy) {
        rb.query('sortBy', params.sortBy)
    }
    if (params.sortDirection) {
        rb.query('sortDirection', params.sortDirection)
    }


    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<PaginatedList<QuestionnaireResponseSummaryModel>>;
        })
    );
}

analyticsResponsesGet.PATH = '/api/v1/analytics/questionnaires/{questionnaireGuid}/responses';
